import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const GallerySection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const images = [
    'https://customer-assets.emergentagent.com/job_headspace-admin/artifacts/vpg7bm03_Imagen%20de%20WhatsApp%202025-05-06%20a%20las%2021.03.24_e6a314bc.jpg',
    'https://customer-assets.emergentagent.com/job_headspace-admin/artifacts/y912rpby_HP_Banner_image.webp',
    'https://customer-assets.emergentagent.com/job_headspace-admin/artifacts/cmwjx46x_Z.jpeg',
    'https://customer-assets.emergentagent.com/job_headspace-admin/artifacts/ige5g2mw_AdobeStock_280340375-scaled.jpg',
  ];

  return (
    <section className="relative py-20 px-6 bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a] overflow-hidden">
      <motion.div
        ref={ref}
        className="relative max-w-7xl mx-auto"
      >
        {/* Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-5xl md:text-6xl font-light mb-4">
            <span className="text-white">La Experiencia</span>{' '}
            <span className="text-[#C9A86A] font-medium">
              MAUMA
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Un espacio diseñado para tu bienestar y renovación
          </p>
        </motion.div>

        {/* Image grid with stagger effect */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {images.map((image, index) => (
            <motion.div
              key={index}
              className="relative overflow-hidden rounded-2xl aspect-square group cursor-pointer"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ scale: 1.05, zIndex: 10 }}
            >
              <img
                src={image}
                alt={`Galería ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <motion.div
                className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default GallerySection;
